export default "__VITE_ASSET__EXCgnaKI__"